export default __webpack_public_path__ + "static/media/respiratory-shadow.5b66d2fa.svg";